import React from 'react';

class HeadImage extends React.Component {
    render() {
        return (
        <div className="col-lg-12 col-sm-2">
            <a href="https://lostickaveselka.cz/">
                <div className="enjoy-css align-bottom" alt="Loštická veselka">
                    <p className="nadpis text-center align-bottom">Loštická Veselka</p>
                </div>
            </a>
        </div>
    )}
}

export default HeadImage;
